(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ce-brands"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){const btn=e.target.closest('[data-ce-brand-prev],[data-ce-brand-next]');if(!btn)return;const gallery=btn.closest('.ce-logo-gallery'),track=gallery.querySelector('.ce-brand-row');const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;track.scrollBy({left:(btn.hasAttribute('data-ce-brand-prev')?-1:1)*track.clientWidth*.8,behavior:reduced?'instant':'smooth'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ce-footer"]) return;
  try {
    
(() => {
  const mobile = window.matchMedia('(max-width:749px)');
  const initialise = (root = document) => {
    root.querySelectorAll('.ce-footer-links:not([data-ce-footer-ready])').forEach(panel => {
      panel.dataset.ceFooterReady = 'true';
      panel.open = true;
      panel.querySelector('summary').addEventListener('click', event => {
        if (!mobile.matches) event.preventDefault();
      });
      panel.addEventListener('toggle', () => {
        if (!mobile.matches && !panel.open) panel.open = true;
      });
    });
  };
  initialise();
  mobile.addEventListener('change', () => {
    document.querySelectorAll('.ce-footer-links').forEach(panel => { panel.open = true; });
  });
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ce-header"]) return;
  try {
    
(() => {
const closeMenus = (except) => document.querySelectorAll('.ce-mega[open]').forEach(el=>{if(el!==except)el.removeAttribute('open')});
document.addEventListener('click',event=>{const summary=event.target.closest('.ce-mega>summary');if(summary&&event.detail>0&&matchMedia('(min-width:990px) and (hover:hover)').matches){event.preventDefault();closeMenus(summary.parentElement);summary.parentElement.setAttribute('open','')}document.querySelectorAll('.ce-mega[open],.ce-mobile-menu[open]').forEach(el=>{if(!el.contains(event.target))el.removeAttribute('open')});if(event.target.closest('[data-ce-close-menu]'))document.querySelector('.ce-mobile-menu')?.removeAttribute('open')});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.ce-mega[open],.ce-mobile-menu[open]').forEach(el=>{el.removeAttribute('open');el.querySelector('summary').focus()})});
document.addEventListener('toggle',event=>{if(event.target.matches('.ce-mega[open]'))closeMenus(event.target)},true);
const bindMenus=()=>document.querySelectorAll('.ce-mega').forEach(el=>{if(el.dataset.ceBound)return;el.dataset.ceBound='true';let timer;el.addEventListener('pointerenter',()=>{if(!matchMedia('(min-width: 990px) and (hover: hover)').matches)return;clearTimeout(timer);closeMenus(el);el.setAttribute('open','')});el.addEventListener('pointerleave',()=>{if(!matchMedia('(hover:hover)').matches)return;timer=setTimeout(()=>{if(!el.contains(document.activeElement))el.removeAttribute('open')},180)})});
bindMenus();document.addEventListener('shopify:section:load',bindMenus);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ce-podcasts"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-ce-podcast-prev],[data-ce-podcast-next]');if(!button)return;const track=button.closest('.ce-podcasts').querySelector('.ce-podcast-track');track.scrollBy({left:(button.hasAttribute('data-ce-podcast-next')?1:-1)*track.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ce-product-details"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href="#CEProductUsage"]');
  if (link) {
    const usage = document.getElementById('CEProductUsage');
    if (usage) usage.open = true;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ce-subcategory-grid"] && !Shopify.designMode) return;
  try {
    
const ceUpdateCategory=(root)=>{const list=root.querySelector('.ce-curated-grid'),items=[...list.children],mode=root.querySelector('[data-ce-sort]').value,brand=root.querySelector('[data-ce-brand-filter]').value,stock=root.querySelector('[data-ce-stock-filter]').checked,minInput=root.querySelector('[data-ce-min]').value,maxInput=root.querySelector('[data-ce-max]').value,min=minInput===''?0:Number(minInput)*100,max=maxInput===''?Infinity:Number(maxInput)*100;items.sort((a,b)=>mode==='asc'?Number(a.dataset.cePrice)-Number(b.dataset.cePrice):mode==='desc'?Number(b.dataset.cePrice)-Number(a.dataset.cePrice):mode==='az'?a.dataset.ceTitle.localeCompare(b.dataset.ceTitle):Number(a.dataset.ceIndex)-Number(b.dataset.ceIndex));let count=0;items.forEach(item=>{const price=Number(item.dataset.cePrice),show=(!brand||item.dataset.ceBrand===brand)&&(item.dataset.ceAvailable==='true')&&price>=min&&price<=max;item.hidden=!show;if(show)count++;list.appendChild(item)});root.querySelector('[data-ce-visible-count]').textContent=count;root.querySelector('[data-ce-empty]').hidden=count>0};
document.addEventListener('change',event=>{if(event.target.matches('[data-ce-control],[data-ce-sort]'))ceUpdateCategory(event.target.closest('[data-ce-curated]'))});document.addEventListener('input',event=>{if(event.target.matches('[data-ce-min],[data-ce-max]'))ceUpdateCategory(event.target.closest('[data-ce-curated]'))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(() => {
  const narrow = window.matchMedia('(max-width: 749px)');
  const initialise = (root = document) => {
    root.querySelectorAll('.ce-mobile-refine:not([data-initialised])').forEach(panel => {
      panel.dataset.initialised = 'true';
      panel.open = !narrow.matches;
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  narrow.addEventListener('change', () => {
    document.querySelectorAll('.ce-mobile-refine').forEach(panel => { panel.open = !narrow.matches; });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
